import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './WordHistory.css';

interface WordEntry {
  word: string;
  explanation: string;
  timestamp: Date;
}

interface WordHistoryProps {
  words: WordEntry[];
}

const WordHistory: React.FC<WordHistoryProps> = ({ words }) => {
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  };

  return (
    <div className="word-history">
      <div className="history-list">
        {words.map((entry, index) => (
          <div key={index} className="history-item">
            <div className="history-header">
              <span className="history-word">🔤 {entry.word}</span>
              <span className="history-time">⏰ {formatTime(entry.timestamp)}</span>
            </div>
            <div className="history-explanation">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {entry.explanation}
              </ReactMarkdown>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WordHistory;